import Image from '@/components/Image';
import SwiperNavigationButtons from '@/components/SwiperNavigation';
import { useMediaQuery } from '@mui/material';
import React from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

interface ForLifeStylesItem {
  image: string;
  image_m?: string;
  btn_word?: string;
  btn_word_m?: string;
  title?: string;
  title_m?: string;
}

interface ForLifeStylesData {
  title: string;
  title_m?: string;
  data_array: ForLifeStylesItem[];
  aspect_ratio?: string;
  aspect_ratio_m?: string;
}

interface ForLifeStylesProps {
  forLifeStylesData: ForLifeStylesData;
}

const ForLifeStyles: React.FC<ForLifeStylesProps> = ({
  forLifeStylesData = { title: '', data_array: [] },
}) => {
  // 获取设备类型
  const isMobileScreen = useMediaQuery('(max-width: 768px)');

  // 获取当前设备对应的数据
  const currentTitle = isMobileScreen
    ? forLifeStylesData.title_m || forLifeStylesData.title
    : forLifeStylesData.title;
  const aspectRatio = isMobileScreen
    ? forLifeStylesData.aspect_ratio_m || '550/660'
    : forLifeStylesData.aspect_ratio || '550/660';

  // 移动端轮播组件
  const renderMobileSwiper = () => (
    <div className="swiper-nav-container relative">
      <Swiper
        modules={[Navigation]}
        slidesPerView="auto"
        spaceBetween={8}
        slidesOffsetBefore={14}
        slidesOffsetAfter={14}
        observer
        observeParents
        observeSlideChildren
        navigation={{
          nextEl: '.for-life-styles-next',
          prevEl: '.for-life-styles-prev',
        }}
        className="w-full"
      >
        {forLifeStylesData.data_array.map((item, index) => {
          const currentImage = item.image_m || item.image;
          const currentBtnWord = item.btn_word_m || item.btn_word;
          const currentTitleM = item.title_m || item.title;
          const currentAlt = currentBtnWord || currentTitleM || '';

          return (
            <SwiperSlide key={index} className="!w-[275px]">
              <div className="for-life-styles-item-box relative flex flex-col items-center justify-center">
                <div className="for-life-styles-item-box-top w-full">
                  <Image
                    src={currentImage}
                    alt={currentAlt}
                    className="w-full h-auto block rounded-[6px]"
                    style={{ aspectRatio }}
                    width={275}
                    height={330}
                  />
                </div>
                {currentBtnWord && (
                  <div className="for-life-styles-item-box-bottom absolute bottom-[16px] left-1/2 transform -translate-x-1/2 min-w-[104px] h-[28px] text-[12px] font-bb text-center leading-[28px] bg-white rounded-[14px] px-[12px]">
                    {currentBtnWord}
                  </div>
                )}
                {currentTitleM && (
                  <h4 className="for-life-styles-item-title absolute bottom-0 left-0 flex items-center justify-center w-full h-1/4 text-[13px] font-bb text-center text-white px-[15px] box-border">
                    {currentTitleM}
                  </h4>
                )}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>

      {/* 导航按钮 */}
      <SwiperNavigationButtons
        navigationPrefix="for-life-styles"
        prevButtonPosition="left-2"
        nextButtonPosition="right-2"
      />
    </div>
  );

  // PC端网格布局组件
  const renderDesktopGrid = () => (
    <ul className="flex  justify-between gap-24 ">
      {forLifeStylesData.data_array.map((item, index) => {
        const currentImage = item.image;
        const currentBtnWord = item.btn_word;
        const currentTitleP = item.title;
        const currentAlt = currentBtnWord || currentTitleP || '';

        return (
          <li key={index} className="w-full md:w-1/3">
            <div className="for-life-styles-item-box relative flex flex-col items-center justify-center">
              <div className="for-life-styles-item-box-top w-full">
                <Image
                  src={currentImage}
                  alt={currentAlt}
                  className="w-full h-auto block rounded-[12px]"
                  style={{ aspectRatio }}
                  width={464}
                  height={557}
                />
              </div>
              {currentBtnWord && (
                <div className="for-life-styles-item-box-bottom absolute bottom-[20px] left-1/2 transform -translate-x-1/2 min-w-[140px] h-[40px] text-[14px] font-bb text-center leading-[40px] bg-white rounded-[20px] px-[16px]">
                  {currentBtnWord}
                </div>
              )}
              {currentTitleP && (
                <h4 className="for-life-styles-item-title absolute bottom-0 left-0 flex items-center justify-center w-full h-1/4 text-[16px] md:text-[1.25vw] font-bb text-center text-white px-[16px] box-border">
                  {currentTitleP}
                </h4>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );

  return (
    <div className="w-full box-border pb-[40px] md:px-[240px] md:my-[120px]">
      <div className="lenses-for-life-box px-[14px] md:px-0 mb-[20px] md:mb-[32px]">
        <h3 className="text-[24px] leading-[1] md:text-[40px] font-bb text-center">
          {currentTitle}
        </h3>
      </div>

      {/* 移动端显示轮播，PC端显示网格 */}
      {isMobileScreen ? renderMobileSwiper() : renderDesktopGrid()}
    </div>
  );
};

export default ForLifeStyles;
